<!--
 * @Descripttion:过滤条件配置
 * @Author: zenghua.wang
 * @Date: 2021-09-01 10:55:13
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-12-29 16:36:22
-->
<template>
  <div>
    <el-form-item label="过滤条件">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-setting"
        @click="onFilter"
      >设置</el-button>
    </el-form-item>

    <div style="margin: 10px 0">
      <el-table
        :data="data.option.reqParams"
        border
        size="small"
        style="width: 100%"
      >
        <el-table-column label="参数名">
          <template slot-scope="scope">
            {{ scope.row.prop }}
            <span v-if="scope.row.label">（{{ scope.row.label }}）</span>
          </template>
        </el-table-column>

        <el-table-column
          fixed="right"
          label="操作"
          width="140"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              icon="el-icon-edit"
              @click="editFilter(data.option.reqParams, scope.$index)"
            ></el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-delete"
              @click="deleteFilter(scope.row, scope.$index)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 过滤条件弹窗 -->
    <config-filter-dialog
      :loading="filterLoading"
      :dialog="filterDialog"
      :data="data"
      :column="filterColumn"
      :widgets="widgets"
      :params="main.outerParams"
      @change="updateFilter"
    />
  </div>
</template>
<script>
import apiParams from '@/dragComponents/mixins/apiParams.js'

import configFilterDialog from '@/dragComponents/config/common/dialog/filter.vue'

export default {
  name: 'echart-filter',
  mixins: [apiParams],
  components: {
    configFilterDialog
  },
  props: ['data'],
  data() {
    return {}
  },
  methods: {
    onFilter() {
      this.getConditionWidgets()
      this.addFilter(this.data.option.reqParams)
    }
  }
}
</script>
